import Model, { attr } from '@ember-data/model';
import { cached } from '@glimmer/tracking';

export default class AdminFundGroupModel extends Model {
  @attr('string') name?: string;
  @attr() userIds?: number[];
  @attr() fundIds?: number[];
  @attr('string') role?: string;

  get nameLowerCase() {
    return this.name?.toLowerCase();
  }

  // the userIds array converted to an object of keys for fast searching
  @cached
  get userIdKeys() {
    let userIdKeys: { [index: number]: boolean } = {};
    (this.userIds || []).forEach((userId) => {
      userIdKeys[userId] = true;
    });
    return userIdKeys;
  }

  // the fundIds array converted to an object of keys for fast searching
  @cached
  get fundIdKeys() {
    let fundIdKeys: { [index: number]: boolean } = {};
    (this.fundIds || []).forEach((fundId) => {
      fundIdKeys[fundId] = true;
    });
    return fundIdKeys;
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'admin/fund-group': AdminFundGroupModel;
  }
}
